import EfficeIconLarge from "components/General-UI/EfficeIconLarge";
import AppIcon from "components/Home/ui/AppIcon/AppIcon";
import { isRootEffice } from "helpers/efficeHelpers";
import history from "constants/history";
import React from "react";
const JoiningEfficeDeets = ({ inviteEffice }) => {
  // if there is a current user, it means they need to go to sign In page,
  // if not it means they jumped straigt into the app with this route (possibly by a bookmark), in which we should send them to home page which will check for auth and redirect if necessary
  return (
    <div className="join-deets-container">
      <div className="d-flex justify-content-between w-100">
        <span className="join-you-are">{`You are invited to`}</span>
        <div
          onClick={() => {
            history.push("/");
          }}
          className="action-light-side-text d-inline-block"
        >
          cancel?
        </div>
      </div>

      <div className="join-effice-deet-box">
        <div className="d-inline-block">
          {isRootEffice(inviteEffice) ? (
            <EfficeIconLarge
              rootName={inviteEffice.content}
              rootIcon={inviteEffice.avatar_key}
            />
          ) : (
            <span className="branch-icon">
              <AppIcon appId={inviteEffice.app_id} />
            </span>
          )}
        </div>
        <div className="join-effice-deet-title">{inviteEffice.content}</div>
      </div>
    </div>
  );
};

export default JoiningEfficeDeets;
